// Packages
import Vue from 'vue'
import Router from 'vue-router'
import FloatingVue from 'floating-vue'
import moment from 'moment'
import VueProgressBar from 'vue-progressbar'
import vSelect from 'vue-select'
import VueAnalytics from 'vue-analytics'
// Helpers
import router from './router'
import store from './store/index'
// Mixin
import Alerter from './utils/alertMixin'
import consoleMixin from './utils/consoleMixin'
import SentryMixin from './utils/sentryMixin'
// Plugins
import { Auth0Plugin } from './utils/auth/auth0Plugin'
import Hotjar from 'vue-hotjar'
// Components
import App from './App.vue'
import { ToastrPlugin } from './components/toastr-alert'
// Directives
import ClickOutside from './utils/click-outside'

// if (process.env.NODE_ENV !== 'production') {
//   const script = document.createElement('script')
//   const target = document.querySelector('body')

//   script.async = true
//   script.src = '/dynatrace.js'
//   script.type = 'text/javascript'

//   target.appendChild(script)
// }

vSelect.props.components.default = () => {
  return {
    Deselect: {
      render: (createElement) => {
        return createElement('i', { class: 'fa fa-x' })
      },
    },
    OpenIndicator: {
      render: (createElement) => {
        return createElement('i', { class: 'fa fa-select-arrows' })
      },
    },
  }
}

Vue.component('VSelect', vSelect)
Vue.directive('click-outside', ClickOutside)
Vue.mixin(Alerter)
Vue.mixin(consoleMixin)
Vue.mixin(SentryMixin)
Vue.use(Router)
Vue.use(Auth0Plugin)
Vue.use(FloatingVue)
Vue.use(ToastrPlugin)
Vue.use(VueProgressBar, {
  autoFinish: false,
  color: '#61AC87',
  failedColor: '#CC5A5A',
  thickness: '5px',
})
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
  router,
})
Vue.use (Hotjar, {
  id: process.env.VUE_APP_HOTJAR_SITE_ID,
  isProduction: process.env.VUE_APP_ENV === 'production',
  snippetVersion: 6,
})

Vue.config.devtools = true
Vue.config.productionTip = false

Vue.filter('datetime', (datetime, format = 'MM/DD/YYYY') => {
  if (!datetime) {
    return null
  }
  return moment(datetime).format(format)
})

const app = new Vue({
  router,
  store,
  render: (h) => {
    return h(App)
  },
}).$mount('#app')

export default app
